import { trackEvents } from "@/common/events/events";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
import { CARS_PRICES_BASE_PATH } from "@/pages/car-prices/helpers/carsPricesHelpers";
import { URL_SELL_TRADE_LANDING_v2 } from "@/pages/sell-trade-v2/sell-trade/constants";
import { FavoritesIcon, MyInformationIcon, RecentlyViewedIcon, SavedSearchesIcon, TrackOrdersIcon } from "./accountNavIcons";
import { AboutUsIcon, AffiliateIcon, CarPricesIcon, CareersIcon, CarsAndVehiclesIcon, CarsFinancingIcon, CarsGuideIcon, CarsOffersIcon, CitiesIcon, LogoutIcon, CompanyLocationIcon, CompareCarsIcon, ContactUsIcon, FinanceCalculatorIcon, NewCarsOffersIcon, ServiceCentersIcon, ServicesIcon, SyarahShowroomIcon, SyarahTrendIcon, UsedCarsOffersIcon } from "./megaNavIcons";
var desktopNavData = function desktopNavData(_ref) {
  var t = _ref.t,
    lang = _ref.lang,
    createUrl = _ref.createUrl,
    isLoggedIn = _ref.isLoggedIn,
    logout = _ref.logout;
  var accountLinks = isLoggedIn ? [{
    id: "nav-my-info",
    title: t("my_information", {
      ns: "web_aside_menu"
    }),
    href: createUrl("/user/account/my-info"),
    IconComponent: MyInformationIcon,
    // Material Symbols ink fills ~20 of its 24 grid, so 24 lands the
    // drawn mark at the 20px the four exported glyphs beside it hit.
    iconSize: 24
  }, {
    id: "nav-favorites",
    title: t("favorites", {
      ns: "web_aside_menu"
    }),
    href: createUrl("/user/favorite"),
    IconComponent: FavoritesIcon
  }, {
    id: "nav-track-orders",
    title: t("track_orders", {
      ns: "web_aside_menu"
    }),
    href: createUrl("/tracking-landing"),
    IconComponent: TrackOrdersIcon,
    // Entry point for order tracking from the account menu. `onSelect`
    // runs alongside the navigation because the row has a real href —
    // only rows with `href: "#"` are treated as actions.
    onSelect: function onSelect() {
      return trackEvents("order_tracking_entry", {
        referral_location: "my_account_menu",
        platform: getPlatformInfo()
      });
    }
  }, {
    id: "nav-saved-searches",
    title: t("saved_searches", {
      ns: "web_aside_menu"
    }),
    href: createUrl("/site/saved-search"),
    IconComponent: SavedSearchesIcon
  }, {
    id: "nav-recently-viewed",
    title: t("recently_viewed_cars", {
      ns: "web_aside_menu"
    }),
    href: createUrl("/site/recently-viewed"),
    IconComponent: RecentlyViewedIcon
  }, {
    id: "nav-logout",
    title: t("logout", {
      ns: "web_header"
    }),
    href: "#",
    IconComponent: LogoutIcon,
    // Exported in a 30x30 frame with the ink inset to 19x18, so 20px drew
    // it at ~13px. 32 brings the mark up to the 20px of its neighbours.
    iconSize: 32,
    tone: "danger",
    onSelect: function onSelect() {
      trackEvents("user_logout", {
        ui_language: lang
      });
      logout();
    }
  }] : [{
    id: "nav-login-signup",
    title: t("login_sign_up", {
      ns: "web_aside_menu"
    }),
    href: createUrl("/user/signup"),
    icon: "material-symbols--login-rounded"
  }, {
    id: "nav-track-orders",
    title: t("track_orders", {
      ns: "web_aside_menu"
    }),
    href: createUrl("/tracking-landing"),
    IconComponent: TrackOrdersIcon,
    // Entry point for order tracking from the account menu. `onSelect`
    // runs alongside the navigation because the row has a real href —
    // only rows with `href: "#"` are treated as actions.
    onSelect: function onSelect() {
      return trackEvents("order_tracking_entry", {
        referral_location: "my_account_menu",
        platform: getPlatformInfo()
      });
    }
  }, {
    id: "nav-favorites",
    title: t("favorites", {
      ns: "web_aside_menu"
    }),
    href: createUrl("/user/favorite"),
    IconComponent: FavoritesIcon
  }, {
    id: "nav-recently-viewed",
    title: t("recently_viewed_cars", {
      ns: "web_aside_menu"
    }),
    href: createUrl("/site/recently-viewed"),
    IconComponent: RecentlyViewedIcon
  }];
  return {
    account: {
      key: "account",
      title: t("account", {
        ns: "web_aside_menu"
      }),
      width: 255,
      columns: [accountLinks]
    },
    browse: {
      key: "browse",
      title: t("browse_syarah", {
        ns: "web_header"
      }),
      width: 560,
      columns: [[{
        id: "nav-all-cars",
        title: t("cars", {
          ns: "web_aside_menu"
        }),
        href: createUrl("/autos"),
        IconComponent: CarsAndVehiclesIcon
      }, {
        id: "nav-used-cars-offers",
        title: t("used_cars_offers", {
          ns: "web_aside_menu"
        }),
        href: createUrl("/filters", {
          condition_id: 0
        }),
        IconComponent: UsedCarsOffersIcon
      }, {
        id: "nav-finance-calculator",
        title: t("car_financing_calculator", {
          ns: "web_aside_menu"
        }),
        href: createUrl("/financing/calculator"),
        IconComponent: FinanceCalculatorIcon
      }, {
        id: "nav-trend",
        title: t("syarah_trend", {
          ns: "web_aside_menu"
        }),
        href: createUrl("/trend"),
        IconComponent: SyarahTrendIcon
      }, {
        id: "nav-compare",
        title: t("car_comparison", {
          ns: "web_aside_menu"
        }),
        href: createUrl("/compare"),
        IconComponent: CompareCarsIcon
      }], [{
        id: "nav-cars-offers",
        title: t("cars_offers", {
          ns: "web_aside_menu"
        }),
        href: createUrl("/offerspage"),
        IconComponent: CarsOffersIcon
      }, {
        id: "nav-new-cars-offers",
        title: t("new_cars_offers", {
          ns: "web_aside_menu"
        }),
        href: createUrl("/filters", {
          condition_id: 1
        }),
        IconComponent: NewCarsOffersIcon
      }, {
        id: "nav-financing",
        title: t("cars_financing", {
          ns: "web_home"
        }),
        href: createUrl("/financing"),
        IconComponent: CarsFinancingIcon
      }, {
        id: "nav-showrooms",
        title: t("syarah_showroom", {
          ns: "web_aside_menu"
        }),
        href: createUrl("/car-showrooms"),
        IconComponent: SyarahShowroomIcon
      }]]
    },
    discover: {
      key: "discover",
      title: t("discover_syarah", {
        ns: "web_header"
      }),
      width: 560,
      columns: [[{
        id: "nav-about-us",
        title: t("about_us", {
          ns: "web_aside_menu"
        }),
        href: createUrl("/about-us"),
        IconComponent: AboutUsIcon
      }, {
        id: "nav-cities",
        title: t("cities", {
          ns: "web_aside_menu"
        }),
        href: createUrl("/city"),
        IconComponent: CitiesIcon
      }, {
        id: "nav-carsguide",
        title: t("carsguide", {
          ns: "web_aside_menu"
        }),
        href: "https://syarah.com/carsguide/".concat(lang === "en" ? "en/" : ""),
        IconComponent: CarsGuideIcon,
        isExternal: true
      }, {
        id: "nav-affiliate",
        title: t("affiliate_program", {
          ns: "web_aside_menu"
        }),
        href: createUrl("/network"),
        IconComponent: AffiliateIcon
      }, {
        id: "nav-careers",
        title: t("careers", {
          ns: "web_aside_menu"
        }),
        href: "https://apply.workable.com/syarah/",
        IconComponent: CareersIcon,
        isExternal: true
      }], [{
        id: "nav-contact-us",
        title: t("call_2", {
          ns: "web_aside_menu"
        }),
        href: createUrl("/contact-us"),
        IconComponent: ContactUsIcon
      }, {
        id: "nav-services",
        title: t("services", {
          ns: "web_aside_menu"
        }),
        href: createUrl("/about-us/services"),
        IconComponent: ServicesIcon
      }, {
        id: "nav-car-prices",
        title: t("car_prices", {
          ns: "web_aside_menu"
        }),
        href: createUrl(CARS_PRICES_BASE_PATH),
        IconComponent: CarPricesIcon
      }, {
        id: "nav-service-centers",
        title: t("service_centers", {
          ns: "web_aside_menu"
        }),
        href: createUrl("/service-centers"),
        IconComponent: ServiceCentersIcon,
        // Figma exports this glyph in a 37x37 frame with the ink inset to
        // roughly 20px, so drawing the svg at 37 lands the visible mark at
        // the same size as the 20px icons around it.
        iconSize: 37
      }, {
        id: "nav-company-location",
        title: t("location", {
          ns: "web_aside_menu"
        }),
        href: createUrl("/contact-us") + "?scrollTo=contact-map",
        IconComponent: CompanyLocationIcon
      }]]
    },
    mainLinks: [{
      id: "nav-buy-cars",
      title: t("buy_cars", {
        ns: "web_header"
      }),
      href: createUrl("/filters"),
      icon: "material-symbols--directions-car-rounded"
    }, {
      id: "nav-buy-services",
      title: t("buy_services", {
        ns: "web_header"
      }),
      href: createUrl("/products/oil"),
      icon: "material-symbols--home-repair-service-rounded"
    }, {
      id: "nav-order-tracking",
      title: t("track_orders", {
        ns: "web_aside_menu"
      }),
      href: createUrl("/tracking-landing"),
      icon: "material-symbols--local-shipping-outline-rounded",
      onSelect: function onSelect() {
        return trackEvents("order_tracking_entry", {
          referral_location: "top_navigation",
          platform: getPlatformInfo()
        });
      }
    }, {
      id: "nav-b2b-sales",
      title: t("b2b_sales", {
        ns: "web_aside_menu"
      }),
      href: createUrl("/fleet"),
      icon: "material-symbols--business-center-outline-rounded"
    }],
    sellCarHref: createUrl(URL_SELL_TRADE_LANDING_v2),
    loginHref: createUrl("/user/signup")
  };
};
export default desktopNavData;